import { useSelector, useDispatch } from 'react-redux';
import { useMemo, useCallback } from 'react';
import {
    selectUser,
    selectToken,
    selectIsAuthenticated,
    selectIsInitialized,
    selectIsOwner,
    selectIsManager,
    selectIsStaff,
    selectIsChef,
    selectAssociatedRestaurant,
    selectCanAccessRestaurants,
    selectCanAccessAllRestaurants,
} from '../store/slices/authSlice';
import {
    login as loginAction,
    logout as logoutAction,
    updateUser as updateUserAction,
} from '../store/slices/authSlice';

// useAuth hook - maintains same API as AuthContext
export const useAuth = () => {
    const dispatch = useDispatch();
    const user = useSelector(selectUser);
    const token = useSelector(selectToken);
    const isAuthenticated = useSelector(selectIsAuthenticated);
    const isInitialized = useSelector(selectIsInitialized);
    const isOwner = useSelector(selectIsOwner);
    const isManager = useSelector(selectIsManager);
    const isStaff = useSelector(selectIsStaff);
    const isChef = useSelector(selectIsChef);
    const associatedRestaurant = useSelector(selectAssociatedRestaurant);
    const canAccessRestaurants = useSelector(selectCanAccessRestaurants);
    const canAccessAllRestaurants = useSelector(selectCanAccessAllRestaurants);

    const login = useCallback(async (user, token) => {
        dispatch(loginAction({ user, token }));
        return user;
    }, [dispatch]);

    const logout = useCallback(async () => {
        dispatch(logoutAction());
    }, [dispatch]);

    const updateUser = useCallback(async (user) => {
        dispatch(updateUserAction(user));
        return user;
    }, [dispatch]);

    return useMemo(() => ({
        user,
        token,
        isAuthenticated,
        isInitialized,
        login,
        logout,
        updateUser,
        isOwner: () => isOwner,
        isManager: () => isManager,
        isStaff: () => isStaff,
        isChef: () => isChef,
        getAssociatedRestaurant: () => associatedRestaurant,
        canAccessRestaurants: () => canAccessRestaurants,
        canAccessAllRestaurants: () => canAccessAllRestaurants,
    }), [user, token, isAuthenticated, isInitialized, login, logout, updateUser, isOwner, isManager, isStaff, isChef, associatedRestaurant, canAccessRestaurants, canAccessAllRestaurants]);
};

export default useAuth;

